// extracted by mini-css-extract-plugin
export default {"header":"order-details_header__z06rl","details":"order-details_details__XdOpV"};